export default "__VITE_ASSET__DBk6HKR3__"